export interface Address {
    id: string | number;
    name?: string;
    address?: string;
    icon?: string;
    nom_adresse?: string;
    adresse_complete?: string;
}

export interface WizardOrderData {
    geographicScope: 'urban' | 'interurban';
    deliveryType: string;
    deliveryProfile: 'community' | 'professional';
    pickupAddress: string;
    deliveryAddress: string;
    useCurrentLocation: boolean;
    packageDetails: {
        size: string;
        weight: string;
        specialInstructions: string;
        declaredValue?: number;
        insuranceEnabled?: boolean;
    };
    paymentMethod: string;
}

export const GEOGRAPHIC_SCOPES = [
    {
        id: 'urban',
        name: 'Urbain',
        description: 'Livraison intra-muros (Conakry et environs)',
        icon: 'ri-building-line',
        color: 'bg-teal-500',
        basePrice: 2000,
        features: ['Livraison rapide (2-4h)', 'Tarification au km', 'Disponible immédiatement']
    },
    {
        id: 'interurban',
        name: 'Interurbain',
        description: 'Livraison entre villes (Conakry - Mamou - Kankan, etc.)',
        icon: 'ri-road-map-line',
        color: 'bg-sky-500',
        basePrice: 5000,
        features: ['Trajets inter-villes', 'Planification requise', 'Tarification distance']
    }
];

export const DELIVERY_PROFILES = [
    {
        id: 'community',
        name: 'Livreur Communautaire',
        description: 'Voisins et particuliers - Économique',
        icon: 'ri-group-line',
        color: 'bg-purple-500',
        priceMultiplier: 0.6,
        features: ['Coût réduit de 40%', 'Délais plus longs', 'Renforcement communautaire']
    },
    {
        id: 'professional',
        name: 'Livreur Professionnel',
        description: 'Coursiers certifiés - Rapide et fiable',
        icon: 'ri-truck-line',
        color: 'bg-blue-500',
        priceMultiplier: 1.0,
        features: ['Priorité maximale', 'Assurance incluse', 'Suivi GPS temps réel']
    }
];

export const DELIVERY_TYPES = [
    {
        id: 'express',
        name: 'Express',
        description: 'Livraison en moins de 2h',
        icon: 'ri-flashlight-line',
        color: 'bg-rose-500',
        priceMultiplier: 1.5,
        features: ['Suivi GPS temps réel', 'Priorité maximale', 'Assurance incluse']
    },
    {
        id: 'standard',
        name: 'Standard',
        description: 'Livraison en 4-6h',
        icon: 'ri-time-line',
        color: 'bg-emerald-500',
        priceMultiplier: 1.0,
        features: ['Tarification standard', 'Fiabilité garantie', 'Suivi en temps réel']
    },
    {
        id: 'groupee',
        name: 'Groupée',
        description: 'Économique, 4-6h',
        icon: 'ri-group-line',
        color: 'bg-amber-500',
        priceMultiplier: 0.7,
        features: ['Jusqu\'à 70% d\'économies', 'Livraison communautaire', 'Écologique']
    },
    {
        id: 'specialisee',
        name: 'Spécialisée',
        description: 'Produits fragiles',
        icon: 'ri-shield-check-line',
        color: 'bg-violet-500',
        priceMultiplier: 1.3,
        features: ['Conditions spéciales', 'Livreurs formés', 'Emballage sécurisé']
    }
];

export const PACKAGE_SIZES = [
    { id: 'small', name: 'Petit', description: 'Jusqu\'à 30cm', icon: 'ri-archive-line' },
    { id: 'medium', name: 'Moyen', description: '30-60cm', icon: 'ri-inbox-line' },
    { id: 'large', name: 'Grand', description: '60-100cm', icon: 'ri-archive-2-line' },
    { id: 'xlarge', name: 'Très grand', description: 'Plus de 100cm', icon: 'ri-truck-line' }
];

export const PACKAGE_WEIGHTS = [
    { id: 'light', name: 'Léger', description: 'Moins de 5kg' },
    { id: 'medium', name: 'Moyen', description: '5-15kg' },
    { id: 'heavy', name: 'Lourd', description: '15-30kg' },
    { id: 'very-heavy', name: 'Très lourd', description: 'Plus de 30kg' }
];

export const PAYMENT_METHODS = [
    {
        id: 'mobile_money',
        name: 'Mobile Money',
        icon: 'ri-smartphone-line',
        description: 'Orange Money, MTN MoMo, Moov',
        color: 'bg-amber-500'
    },
    {
        id: 'cash',
        name: 'Espèces',
        icon: 'ri-money-dollar-circle-line',
        description: 'Paiement cash à la livraison',
        color: 'bg-emerald-500'
    },
    {
        id: 'card',
        name: 'Carte Bancaire',
        icon: 'ri-bank-card-line',
        description: 'Visa, Mastercard',
        color: 'bg-blue-500'
    }
];